import { of, timer } from 'rxjs'
import { exhaustMap, map, switchMap } from 'rxjs/operators'
import { Component, OnInit } from '@angular/core'
import { Notification, NotificationLinkTypes } from '@tv3/store/notification/notification.model'
import { NotificationService } from '@tv3/store/notification/notification.service'
import { Destroyable, untilDestroy } from '@tokeet/tv3-platform'
import { NotificationDetailService } from '@tv3/services/notification-detail.service'
import { Store } from '@ngrx/store'
import { orderBy } from 'lodash'
import { PushRatesOverlayService } from '@tv3/containers/rates/push-rates/push-rates-overlay.service'

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent extends Destroyable implements OnInit {
  allNotifications: Notification[] = []
  notifications: Notification[] = []
  unreadCount = 0

  theme = {
    booked: {
      details: true,
      class: 'booking',
      icon: 'far fa-calendar-check',
    },
    cancelled: {
      details: true,
      class: 'cancellation',
      icon: 'fal fa-receipt',
    },
    inquiry: {
      details: true,
      class: 'inquiry',
      icon: 'fal fa-receipt',
    },
    paid: {
      details: true,
      class: 'paid',
      icon: 'far fa-money-bill-alt',
    },
    signed: {
      class: 'signed',
      icon: 'fas fa-file-signature',
    },
    rejected: {
      class: 'rejection',
      icon: 'far fa-times-circle',
    },
    succeeded: {
      details: true,
      class: 'succeeded',
      icon: 'far fa-money-bill-alt',
    },
    failed: {
      details: true,
      class: 'failed',
      icon: 'far fa-money-bill-alt',
    },
  }

  tabs = [
    {
      id: 'all',
      amount: 0,
      title: 'All',
      icon: 'fas fa-circle',
    },
    {
      id: 'inquiry',
      amount: 0,
      title: 'Inquiry',
      icon: 'fas text-inquiry fa-circle',
    },
    {
      id: 'booked',
      amount: 0,
      title: 'Booking',
      icon: 'fas text-booking fa-circle',
    },
    {
      id: 'cancelled',
      amount: 0,
      title: 'Cancellation',
      icon: 'fas text-cancellation fa-circle',
    },
    {
      id: 'paid',
      amount: 0,
      title: 'Paid',
      icon: 'fas text-paid fa-circle',
    },
    {
      id: 'signed',
      amount: 0,
      title: 'Signed',
      icon: 'fas text-signed text-success fa-circle',
    },
    {
      id: 'rejected',
      amount: 0,
      title: 'Rejection',
      icon: 'fas text-rejection fa-circle',
    },
  ]

  activeTab

  constructor(
    private store: Store<any>,
    private pushRatesOverlayService: PushRatesOverlayService,
    private notificationService: NotificationService,
    private notificationDetailService: NotificationDetailService
  ) {
    super()
  }

  ngOnInit() {
    this.activeTab = this.tabs[0]

    of(true)
      .pipe(
        switchMap(() => timer(100, 1000 * 60)),
        exhaustMap(() => this.notificationService.getUnreadCount()),
        untilDestroy(this)
      )
      .subscribe((data) => {
        this.unreadCount = data.newcount
      })
  }

  onShown() {
    this.notificationService
      .all()
      .pipe(map((n2) => orderBy([...n2], ['date'], ['desc'])))
      .subscribe((notifications) => {
        this.allNotifications = notifications.filter((i) => i.type && i.linkType != NotificationLinkTypes.HoldEvent)
        const stats = this.allNotifications.reduce((res, i) => ({ ...res, [i.type]: (res[i.type] || 0) + 1 }), {})
        this.tabs[0].amount = this.allNotifications.length
        this.tabs.slice(1).forEach((tab) => (tab.amount = stats[tab.id] || 0))
        this.filter()
      })
    this.notificationService.readAll().subscribe(() => {
      this.unreadCount = 0
    })
  }

  onOpen(notification: Notification) {
    this.notificationDetailService.openDetail(notification)
  }

  onTabClick(tab) {
    this.activeTab = tab
    this.filter()
  }

  filter() {
    this.notifications = this.allNotifications
      .filter((i) => this.activeTab.id === 'all' || i.type === this.activeTab.id)
      .slice(0, 10)
  }

  getTitleHtml(notification) {
    return notification.title.replace(/^\s*\w+/, '<strong>$&</strong>')
  }

  onPushRates() {
    this.pushRatesOverlayService.openSide({})
  }
}
